
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/sub/kaip-veikia",
      function () {
        return require("private-next-pages/lt/sub/kaip-veikia.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/sub/kaip-veikia"])
      });
    }
  